<section class="synagogue-panel w-full max-w-6xl mx-auto px-3 md:px-6 py-6 space-y-6" dir="rtl">

  <header class="flex flex-col gap-1">
    <p class="text-base text-ink-500">בית כנסת</p>
    <h1 class="text-3xl font-bold text-primary-700">{{ header }}</h1>
  </header>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
    <a *ngFor="let label of actions"
       [routerLink]="label.link"
       class="card-2026 flex flex-row items-center gap-4 group hover:bg-accent-50 transition-colors min-h-tap"
       [attr.aria-label]="label.txt">
      <span class="flex items-center justify-center w-12 h-12 rounded-xl bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-white transition-colors">
        <i class="material-icons text-2xl" aria-hidden="true">{{ label.icon }}</i>
      </span>
      <span class="text-lg font-semibold text-ink-800">{{ label.txt }}</span>
    </a>
  </div>
</section>
